export default __webpack_public_path__ + "static/media/akriti.4fb1c161.jpg";